import { render, staticRenderFns } from "./qualitysupervision.vue?vue&type=template&id=7ed80a51"
import script from "./qualitysupervision.vue?vue&type=script&lang=js"
export * from "./qualitysupervision.vue?vue&type=script&lang=js"
import style0 from "./qualitysupervision.vue?vue&type=style&index=0&id=7ed80a51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports